import axiosInstance from './axiosInstance';
import { API_ROUTES } from './constants';

// Customers API functions
export const createCustomer = async (customerData) => {
  try {
    const response = await axiosInstance.post(API_ROUTES.CUSTOMERS.CREATE, {
      fullName: customerData.fullName, // required
      email: customerData.email, // required
      password: customerData.password, // required
      mobileNumber: customerData.mobileNumber, // required
      location: customerData.location, // optional.
      image: customerData.image
    });
    return response.data;
  } catch (error) {
    console.error('Error creating customer:', error);
    throw error;
  }
};

export const updateCustomer = async (customerId, updateData) => {
  try {
    const response = await axiosInstance.patch(`${API_ROUTES.CUSTOMERS.UPDATE}/${customerId}`, updateData);
    return response.data;
  } catch (error) {
    console.error('Error updating customer:', error);
    throw error;
  }
};

export const getCustomers = async (queryParams = {}) => {
  try {
    const params = {
      page: queryParams.page || 1,
      search: queryParams.search || '',
    };
    const response = await axiosInstance.get(API_ROUTES.CUSTOMERS.GET, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching customers:', error);
    throw error;
  }
};

export const getAllCustomersWithoutPagination = async () => {
  try {
    const response = await axiosInstance.get(API_ROUTES.CUSTOMERS.GET_ALL);
    return response.data;
  } catch (error) {
    console.error('Error fetching customers:', error);
    throw error;
  }
};

export const getCustomer = async (customerId) => {
  try {
    const response = await axiosInstance.get(`${API_ROUTES.CUSTOMERS.GET}/${customerId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching customers:', error);
    throw error;
  }
};

export const deleteCustomers = async (customerIds) => {
  try {
    const response = await axiosInstance.delete(API_ROUTES.CUSTOMERS.DELETE, {
      data: {
        ids: customerIds // array of numbers, e.g., [1, 2, 3]
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting customers:', error);
    throw error;
  }
};

// Additional functions can be added here as needed